import { render, staticRenderFns } from "./LiveClassItem.vue?vue&type=template&id=910a3f0a&scoped=true"
import script from "./LiveClassItem.vue?vue&type=script&lang=js"
export * from "./LiveClassItem.vue?vue&type=script&lang=js"
import style0 from "./LiveClassItem.vue?vue&type=style&index=0&id=910a3f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910a3f0a",
  null
  
)

export default component.exports